import { useState } from 'react';
import { FilterButton, useTranslate } from 'react-admin';
import PropTypes from 'prop-types';

const CustomFilterButton = ({ className = '', dataLabel, ...props }) => {
    const translate = useTranslate();
    const [isActive, setIsActive] = useState(false);
    const label = dataLabel || translate('common.filter.add');

    const handleClick = () => {
        setIsActive(!isActive);
    };

    return <FilterButton className={`filter-button ${isActive ? 'active' : ''} ${className}`} data-label={label} onClick={handleClick} {...props} />;
};

CustomFilterButton.propTypes = {
    className: PropTypes.string,
    dataLabel: PropTypes.string,
};

export default CustomFilterButton;
